// src/components/Sidebar.jsx
import React from 'react';
import BlockItem from './BlockItem';
import './Sidebar.css';
import PropTypes from 'prop-types';

const BLOCK_CATEGORIES = [
  {
    name: 'TEXTE',
    blocks: [
      { type: 'heading', label: 'Titre', icon: '📄' },
      { type: 'paragraph', label: 'Paragraphe', icon: '📝' },
      { type: 'richtext', label: 'Texte riche', icon: '✨' },
    ],
  },
  {
    name: 'CONTENU',
    blocks: [
      { type: 'image', label: 'Image', icon: '🖼️' },
      { type: 'button', label: 'Bouton', icon: '🔘' },
      { type: 'divider', label: 'Séparateur', icon: '─' },
    ],
  },
  {
    name: 'DONNÉES',
    blocks: [
      { type: 'features', label: 'Liste à points', icon: '✓' },
      { type: 'stats', label: 'Chiffres clés', icon: '📈' },
      { type: 'contact', label: 'Contact', icon: '☎️' },
    ],
  },
  {
    name: 'CTA',
    blocks: [{ type: 'download', label: 'Téléchargement', icon: '⬇️' }],
  },
];

function Sidebar({ onDragStart }) {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>Ajouter des blocs</h3>
        <p>Glissez-déposez sur la page</p>
      </div>
      <div className="blocks-list">
        {BLOCK_CATEGORIES.map((category) => (
          <div key={category.name} className="block-section">
            <div className="block-section-title">{category.name}</div>
            {category.blocks.map((block) => (
              <BlockItem
                key={block.type}
                block={block}
                onDragStart={() => onDragStart(block.type)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  onDragStart: PropTypes.func.isRequired,
};

export default Sidebar;
